<template>
    <el-dialog
            class="selfModal"
            title="编辑文件信息"
            :close-on-click-modal="false"
            :visible="editData.state"
            width="700px"
            :modal="false"
            @close="closeModal()"
            v-loading="loading"
    >
        <div>
            <el-form :model="formValidate"
                     :rules="ruleValidate"
                     ref="formValidate" label-width="80px"
                     class="demo-ruleForm">
                <div style="display: flex;justify-content: center;">
                    <file-modal ref="fileModal" v-if="editData.state" :fileData="fileData" @fileUpload="fileUpload"></file-modal>
                </div>

                <el-form-item label="文件名称" prop="title">
                    <el-input v-model="formValidate.title" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="公文内容" prop="content" style="width: 100%;">
                    <quillEditorCom v-model="formValidate.content"  />
                </el-form-item>
                <el-form-item label="文件分类" prop="fileType">
                    <el-select size="mini" v-model="formValidate.fileType" placeholder="请选文件分类" style="width: 100%;">
                        <el-option v-for="item in selectData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="可见角色" prop="roleIds">
                    <el-select size="mini" v-model="formValidate.roleIds" multiple placeholder="请选择角色" filterable clearable style="width: 100%;">
                        <el-option v-for="item in roleList"
                                   :key="item.roleId"
                                   :label="item.roleName"
                                   :value="item.roleId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="部门" prop="deptName">
                    <el-col :span="21">
                        <el-input disabled size="mini" v-model="formValidate.deptName"></el-input>
                    </el-col>
                    <el-col :span="2" class="ml20">
                        <el-button @click="changeUserDept" icon="el-icon-menu"></el-button>
                    </el-col>
                </el-form-item>
                <!-- <el-form-item label="关键字" prop="keyword">
                    <el-input v-model="formValidate.keyword" size="mini" style="width: 90%;"></el-input>
                </el-form-item>
                <el-form-item label="文件描述" prop="describe">
                    <el-input
                            style="width: 90%;"
                            type="textarea"
                            :autosize="{minRows: 2,maxRows: 5}"
                            placeholder="文件描述"
                            v-model="formValidate.describe"
                    ></el-input>
                </el-form-item> -->
            </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
             <el-button type="primary" @click="submitForm('formValidate')"
                        :disabled="subDisabled">确 认</el-button>
             <el-button @click="closeModal('')">关闭</el-button>
        </span>
        <el-dialog
                class="deptDialog"
                :close-on-click-modal="false"
                :visible.sync="chooseDepartment.state"
                width="480px"
                title="部门选择"
                :modal="false"
        >
            <div class="modaltree">
                <treeMenu
                        ref="treeMenu"
                        initId="0"
                        :showArrow="false"
                        :showShadow="false"
                        :isEdit="false"
                        loadStyle="staticLoad"
                        @nodeClick="nodeIdModal"
                        :showBox="false"
                ></treeMenu>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="depTreeBtn('1')">确 定</el-button>
            </span>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import {tHallPolicyFileUpdate,tabsList, tHallPolicyFileId } from '@/api/portrayal/policy'
    import fileModal from '@/components/dialog/common/uploadModal_tea.vue'
    import {getList} from '@/api/system/role'
    import {sysFileUpload} from '@/api/managementCenter/otherApi'
    import quillEditorCom from '@/components/common/quillEditor.vue'
    import treeMenu from '@/components/treeMenu/index.vue'
    export default {
        name: "editModal",
        props: {
            editData: {
                type: Object,
                required: true
            }
        },
        components:{
            fileModal,
            quillEditorCom,
            treeMenu
        },
        data(){
            return{
                subDisabled: false,
                roleList: [],
                chooseDepartment: {
                    state: false,
                    data: {},
                    showBox: false
                },
                fileData:{
                    proName: '点击选择上传文件',
                    isActive: true
                },
                formValidate: {
                    title: null,
                    fileType: 0,
                    fileId: '',
                    roleIds: [],
                    id: '',
                    deptId: '',
                    deptName: '',
                    content: '',
                }, // 表单数据绑定
                ruleValidate: {
                    content: [
                        {required: true, message: '内容不能为空', trigger: 'blur'}
                    ],
                    title: [
                        {required: true, message: '该项必须填写', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    fileType: [
                        {required: true, message: '该项必须填写', trigger: 'blur'},
                    ],
                    roleIds: [
                        {required: true, message: '权限不能为空', trigger: 'change'}
                    ],
                    deptName: [
                        {required: true, message: '请选择部门', trigger: 'change'}
                    ],
                }, // 表单验证
                selectData: [],
                loading: false,
            }
        },
        created(){
            this.getRoleList()
        },
        methods:{
            getRoleList(){
                getList()
                .then(({data}) => {
                    if(data.code == 0){
                        data.data.forEach((item) => {
                            item.roleId = String(item.roleId)
                        })
                        this.roleList = data.data;
                    }else {
                        this.$message.error(data.msg)
                    }
                })
            },
            getForm(){
                let o = this.editData.data

                this.formValidate.title= o.title
                this.formValidate.fileId= o.fileId
                this.formValidate.id= o.id
                this.formValidate.content= o.content
                this.formValidate.deptId = o.deptId
                this.formValidate.deptName = o.deptName
                this.formValidate.fileType= o.fileType ? Number(o.fileType) : ''
                this.loading = true;
                tHallPolicyFileId(o.id).then(({data}) => {
                    if(data.code == 0){
                        this.formValidate.roleIds = data.data.fileRole.map((item) => {
                            return item.roleId
                        });
                    }
                }).finally(() => {
                    this.loading = false;
                })
            },
            // 更换部门名称弹框
            changeUserDept() {
                this.chooseDepartment.data = {};
                this.chooseDepartment.chooseBox = false;
                this.chooseDepartment.state = true;
            },
            nodeIdModal(tree) {
                console.log(tree)
                this.chooseDepartment.data = tree
            },
            // 新增-部门选择确认按钮
            depTreeBtn() {
                this.formValidate.deptId = this.chooseDepartment.data.id;
                this.formValidate.deptName = this.chooseDepartment.data.name;
                this.chooseDepartment.state = false
            },
            showAddData() {
                this.selectData = [];
                let data = [];
                let tabsData = [];
                let url = null;
                // if (this.$route.path == '/policyFile') {
                //     url = '/admin/dict/type/file_type'
                // } else {
                //     url = '/admin/dict/type/file_type_stu'
                // }
                url = '/admin/dict/type/policy_type'
                tabsList(url).then(res => {
                    if (res.data.code == 0) {
                        res.data.data.forEach(e => {
                            let o = {
                                id: Number(e.value),
                                name: e.label,
                                hasChildren: true
                            }
                            tabsData.push(o)
                        })
                        data = tabsData;
                        data.forEach(e => {
                            this.selectData.push(e)
                        });

                        // this.selectData.unshift({
                        //     name: '全部',
                        //     id: 0,
                        //     hasChildren: true,
                        // });
                        // let obj = {}; //数组对象去重
                        // this.selectData = this.selectData.reduce(function (item, next) {
                        //     obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
                        //     return item;
                        // }, []);
                    }
                })
                /*if (this.addData.tabsId) {
                    this.formValidate.fileType = this.addData.tabsId;
                } else {
                    this.formValidate.fileType = 0
                }*/
            },
            closeModal(){
                this.$emit('closeEdit', false)
            },
            fileUpload(files){
                if(files.length > 0){
                    let fd = new FormData();
                    fd.append('fromTarget','0')
                    fd.append('file',files[0]);
                    sysFileUpload(fd).then(({data})=>{
                        if(data.code == 0){
                            this.formValidate.title =data.data.fileName;
                            this.subDisabled = false;
                            this.formValidate.fileId =data.data.id;
                            this.$refs.fileModal.getData('已选择上传文件',true)
                        }
                    }).catch((e) => {
                        // console.log(e);
                    });

                }
            },
            submitForm(formNames){
                this.$refs[formNames].validate((valid) => {
                    if (valid) {
                        this.subDisabled = true;

                        let obj = {};
                        obj.fileRole = this.formValidate.roleIds.map((item) => {
                            return {roleId: String(item)}
                        })
                        obj = Object.assign(obj, this.formValidate)
                        tHallPolicyFileUpdate(obj).then(res => {
                            this.subDisabled = false;
                            if (res.data.code == 0) {
                                this.$message({message: '编辑成功', type: 'success'});
                                this.closeModal()
                                this.$store.commit("clearDefaultChecked");
                            } else {
                                this.$message.warning(res.data.msg);
                            }
                        }).finally(() => {
                            this.subDisabled = false;
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>
